import { ForgeDefaultProjectRole, ForgeProjectAccessMode, ForgeProjectRole, } from "@supernova-studio/model";
import { DTOFileReference } from "../files";
import { DTOForgeProjectArtifactCreateInput } from "./project-artifact";
import { DTOForgeProjectFeatureCreateInput } from "./project-feature";
import { DTOCreateForgeProjectInvitation } from "./project-invitation";
import { z } from "zod";
export const DTOForgeProjectRole = ForgeProjectRole;
export const DTOForgeProjectAccessMode = ForgeProjectAccessMode;
export const DTOForgeProjectDefaultRole = ForgeDefaultProjectRole;
export const DTOForgeProjectDocumentPreview = z.object({
    id: z.string(),
    title: z.string(),
    thumbnail: DTOFileReference.optional(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const DTOForgeProjectFeaturePreview = z.object({
    id: z.string(),
    name: z.string(),
    thumbnail: DTOFileReference.optional(),
    isPublished: z.boolean().optional(),
    isArchived: z.boolean().optional(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const DTOForgeProject = z.object({
    id: z.string(),
    workspaceId: z.string(),
    projectContextId: z.string(),
    name: z.string(),
    description: z.string().optional(),
    instruction: z.string().nullable(),
    tags: z.array(z.string()).default([]),
    accessMode: DTOForgeProjectAccessMode,
    defaultRole: DTOForgeProjectDefaultRole,
    isArchived: z.boolean(),
    emoji: z.string().optional(),
    tokenThemeSetId: z.string().optional(),
    createdAt: z.coerce.date(),
    createdByUserId: z.string().optional(),
    lastUserActivityAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date(),
    documents: DTOForgeProjectDocumentPreview.array(),
    features: DTOForgeProjectFeaturePreview.array(),
    liveblocksRoomId: z.string().optional(),
});
export const DTOForgeProjectCreate = DTOForgeProject.pick({
    name: true,
    description: true,
    instruction: true,
    tags: true,
    emoji: true,
    tokenThemeSetId: true,
}).extend({
    projectContextId: z.string().optional(),
    membersToInvite: DTOCreateForgeProjectInvitation.array().min(1).optional(),
    initialFeature: DTOForgeProjectFeatureCreateInput.optional(),
    initialArtifact: DTOForgeProjectArtifactCreateInput.optional(),
    accessMode: DTOForgeProjectAccessMode.optional(),
    defaultRole: DTOForgeProjectDefaultRole.optional(),
});
export const DTOForgeProjectUpdate = DTOForgeProjectCreate.omit({
    membersToInvite: true,
})
    .partial()
    .extend({
    id: z.string(),
    isArchived: z.boolean().optional(),
});
export const DTOForgeProjectListResponse = z.object({
    projects: z.array(DTOForgeProject.extend({
        effectiveRole: DTOForgeProjectRole,
    })),
});
export const DTOForgeProjectResponse = z.object({
    project: DTOForgeProject.extend({
        effectiveRole: DTOForgeProjectRole,
    }),
});
